import classNames from 'classnames'
import React from 'react'

interface Props {
    logo?: string
    montantEnvoyer : string
    montanPayer : string
 
    On? : boolean
    indexRecharge?: number
    index: number
    widhtLogo? : string

}

const carteFact : React.FC<Props> = ({logo,montantEnvoyer,montanPayer,indexRecharge, On, index, widhtLogo }) => {
    return (
    <div className={` ${On && indexRecharge === index && 'border border-[#5754E5] bg-[#E2E2FB] rounded-[20px]'} h-[132px] w-[275px]  xl:w-[300px] cursor-pointer flex items-center`} >

    <div className={` ${indexRecharge === index ? ' border-[4px] border-[#FFF] bg-[#E2E2FB]' : On ? ' opacity-55 bg-[#EEEEEE]': 'bg-[#EEEEEE]'} w-full h-full rounded-[20px] p-3  `}>
        <img  className={classNames( widhtLogo,'h-[40px] w-auto')} src={logo} alt='logo'  />
        <div className= {`${indexRecharge === index ?  'text-[#35258B]': 'text-[#767676] ' } flex justify-between items-baseline `} >
            <div className='leading-7 '>
                <h3 className='font-bold text-[10px]'>Montant de la facture</h3>
                <h2 className=' flex gap-1 items-stretch text-[32px] font-extrabold'> {montantEnvoyer}  <span className='text-[22px] -mt-2 '>TND</span></h2>

            </div>
            <div className='flex flex-col items-end leading-5'>
                <h3 className='font-bold text-[10px]'>Montant à payer</h3>
                <h2 className='font-bold'>{Number(montanPayer).toFixed(2)}<span> €</span></h2>
                <div className=' font-normal text-[10px]'>Inclus 1 € de frais</div>

            </div>

        </div>
 
    </div>

    </div>
  )
}

export default carteFact
